import { defaultRouteForRole } from '../utils/navigation';

export function resolveAuthNavigation(to, isAuthenticated, userRole) {
  const { requiresAuth, requiresRole } = to.meta || {};

  if (!requiresAuth && isAuthenticated && ['Login', 'Register'].includes(to.name)) {
    return defaultRouteForRole(userRole);
  }
  if (requiresAuth && !isAuthenticated) return '/login';
  if (requiresAuth && to.name === 'Home' && ['user', 'guest'].includes(userRole)) return '/portal';
  if (requiresAuth && requiresRole && userRole !== requiresRole) return '/no-access';
  return true;
}
